module.exports = __webpack_public_path__ + "img/map_Z2.4.E.05.6dc9a2f3.svg";